export default function F7Event(intent) {
  return new window.CustomEvent('f7', {
    detail: {
      intent
    },
    bubbles: true
  });
}
